import { Tabs } from "antd";
import React, { useState } from "react";
import { RuleEngineConstants } from "./constants";
import TicketProcessingRules from "./TicketProcessingRules";

const RuleEngineView = () => {

    const { TabPane } = Tabs;
    const { TICKET_PROCESSING_TAB, TAB_SIZE } = RuleEngineConstants;

    const [currentTab, setCurrentTab] = useState("1");

    return (
        <Tabs
            swipeable
            size={TAB_SIZE}
            defaultActiveKey={"1"}
            activeKey={currentTab ?? "1"}
            onChange={(key) => setCurrentTab(key)}  
        >
            <TabPane
                tab={TICKET_PROCESSING_TAB}
                key={"1"}
            >
                <TicketProcessingRules />
            </TabPane>
        </Tabs>
    )
};

export default RuleEngineView;